import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import useHttp from "../../../hooks/useHttp";
import { ORDERS_GET_URL, DISPUTES_GET_URL } from "../../../utils/api-ends";
import Rating from "../../../components/Rating";
import LoaderImg from "../../../assets/media/loader.gif";

const OrderList = () => {
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const [orderList, setOrderList] = useState([]);
  const [nextPageNumber, setNextPageNumber] = useState("");
  const [orderListFor, setOrderListFor] = useState("1");
  const { isLoading, sendRequests } = useHttp();
  const { isLoading: isLoadMoreOrder, sendRequests: loadMoreOrderRequest } =
    useHttp();

  useEffect(() => {
    const response = (data) => {
      setOrderList(...orderList, data.results);
      setNextPageNumber(data.pagination.next_page_number);
    };
    // Send request to get Order list
    sendRequests(
      {
        url: ORDERS_GET_URL(1, 1),
        method: "GET",
      },
      response
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const orderStatusChange = (e) => {
    const listFor = e.target.getAttribute("data-status");
    const notRatingOrder = e.target.getAttribute("not_rating_order")
    let params = {}
    setOrderListFor(listFor);

    if(notRatingOrder === 'true'){
      params['not_rating_order'] = true;
    }

    //document.getElementsByTagName('button').remove("current-nav")
    var elems = document.querySelectorAll(".order-status-button");
    [].forEach.call(elems, function (el) {
      el.classList.remove("current-nav");
    });
    const list_url =
      listFor === "disputed" ? DISPUTES_GET_URL(1) : ORDERS_GET_URL(listFor, 1);
    e.target.classList.add("current-nav");

    const response = (data) => {
      setOrderList(data.results);
      setNextPageNumber(data.pagination.next_page_number);
    };

    // Send request to get Order list
    sendRequests(
      {
        url: list_url,
        method: "GET",
        params: params
      },
      response
    );
  };

  //Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      nextPageNumber
    ) {
      const list_url =
        orderListFor === "disputed"
          ? DISPUTES_GET_URL(1)
          : ORDERS_GET_URL(orderListFor, nextPageNumber);

      const response = (data) => {
        if (data?.results?.length > 0) {
          setOrderList([...orderList, ...data.results]);
          setNextPageNumber(data?.pagination?.next_page_number);
        }
      };

      // Send get request to get carrier list
      loadMoreOrderRequest(
        {
          url: list_url,
          method: "GET",
        },
        response
      );
    }
  };

  return (
    <>
      <section id="load-list-navigation">
        <div className="container">
          <div className="load-list-navigation-bars">
            <button
              data-status="1"
              className="current-nav order-status-button"
              onClick={orderStatusChange}
            >
              Waiting
            </button>
            <button
              data-status="2"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Dispatched
            </button>
            <button
              data-status="3"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Picked Up
            </button>
            <button
              data-status="4"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Delivered
            </button>
            <button
              data-status="5"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Finished
            </button>
            <button
              data-status="5"
              not_rating_order="true"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Rating
            </button>
            <button
              data-status="disputed"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Disputed
            </button>
            <button
              data-status="6"
              className="order-status-button"
              onClick={orderStatusChange}
            >
              Canceled
            </button>
          </div>
        </div>
      </section>

      {isLoading ? (
        <div className="loader d-flex justify-content-center mb-5 mt-5">
          <img style={{ width: "35px" }} src={LoaderImg} alt="" />
        </div>
      ) : (
        <section id="load-list-users">
          <div className="container">
            <div className="row">
              {orderList?.length > 0 ? (
                orderList?.map((value, index) => (
                  <div className="col-xl-4 col-md-6">
                    <div className="user-info-and-load-details-card">
                      <div className="loader-user-info mb-3">
                        <div className="loader-user-img">
                          <img
                            src={
                              userData.user_type === "shipper"
                                ? value?.carrier_obj?.profile_picture
                                : value?.shipper_obj?.profile_picture
                            }
                            alt=""
                          />
                        </div>
                        <div>
                          <h1 className="large-text">
                            {userData.user_type === "shipper"
                              ? value.carrier_obj?.name
                              : value.shipper_obj?.name}
                          </h1>
                          <div className="user-rating">
                            <Rating
                              rating={
                                userData.user_type === "shipper"
                                  ? value.carrier_obj?.avg_review_rating
                                  : value.shipper_obj?.avg_review_rating
                              }
                            />
                            <span>
                              (
                              {userData.user_type === "shipper"
                                ? value.carrier_obj?.avg_review_rating
                                : value.shipper_obj?.avg_review_rating}
                              )
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="user-extra-info">
                        <h1 className="large-text">
                          {" "}
                          Total Amount: $ {value.amount}{" "}
                        </h1>
                        <div className="user-extra-info-box">
                          <span>Origin:</span>
                          <span>{value.load_post_obj?.origin_address}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Destination:</span>
                          <span>
                            {value.load_post_obj?.destination_address}
                          </span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Pick Up Date:</span>
                          <span>{value.load_post_obj?.pickup_date}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Load Type:</span>
                          <span>{value.load_post_obj?.load_type_value}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Total Loads:</span>
                          <span>{value.total_loads}</span>
                        </div>
                      </div>

                      <div className="multiple-btn mt-3">
                        <Link to={`/order/details/${value.order_id}`}>
                          Expand
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-notification-data-style">
                  <p>
                    {orderListFor === "1" &&
                      "No Order Available in Waiting Queue - Check Other Queue"}
                    {orderListFor === "2" &&
                      "No Order Available in Dispatched Queue - Check Other Queues"}
                    {orderListFor === "3" &&
                      "No Order Available in Picked Up Queue - Check Other Queues"}
                    {orderListFor === "4" &&
                      "No Order Available in Delivered Queue - Check Other Queues"}
                    {orderListFor === "5" &&
                      "No Order Available in Finished Queue – Check Other Queues"}
                    {orderListFor === "6" && "No Cancelled Order(s) Available"}
                    {orderListFor === "disputed" &&
                      "No Disputed Order(s) Available"}
                  </p>
                </div>
              )}
            </div>
            {isLoadMoreOrder && (
              <div className="loader d-flex justify-content-center mb-5 mt-5">
                <img style={{ width: "35px" }} src={LoaderImg} alt="" />
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default OrderList;
